import { config } from '../../config'
export default {
  methods: {
    testUrl (url) {
      if (/(http|https)|(tel:)|(mailto:)/.test(url)) {
        return url
      } else {
        return config.API + url
      }
    },
    timeDifferenceMinute (date1, date2) {
      const difference = date1 - date2
      return difference / 1000 / 60
    }
  }
}
